module.exports = (__webpack_require__(2))("./core/error.js");


//////////////////
// WEBPACK FOOTER
// delegated ./core/error.js from dll-reference base
// module id = 94
// module chunks = 22